<template>

  <div class="btn-flex-box" >
    <div style="margin-bottom: 20px;text-align: left;">
      <el-button-group v-if="null != editObj && (null == readonlyTag || false === readonlyTag)">
        <el-button
            :type="dataType === 'detail' ? 'primary' : ''"
            @click="changeType('detail')"
        >
          <span tkey="詳情">{{i18n.tkey("lang_details")}}</span>
        </el-button>
        <el-button
            :type="dataType === 'company' ? 'primary' : ''"
            @click="changeType('company')"
        >
          <span tkey="參展公司">{{i18n.tkey("lang_join_hall_company")}}</span>
        </el-button>

        <el-button
            :type="dataType === 'product' ? 'primary' : ''"
            @click="changeType('product')"
        >
          <span tkey="參展產品">{{i18n.tkey("lang_exhibited_products")}}</span>
        </el-button>
      </el-button-group>
      <el-button style="margin-right: 20px;float: right;" @click="goHallView" v-if="null != editObj" tkey="前往3D展會">{{i18n.tkey("lang_goto")}}{{i18n.tkey("lang_3d_exhibition")}}</el-button>
    </div>
  </div>
    <el-form
        v-if="dataType === 'detail'"
        ref="formRef"
        style="max-width: 600px; margin: auto"
        :model="dataForm"
        :rules="rules"
        :disabled="loading"
        label-width="auto"
        v-loading="loading"
    >

        <el-form-item
            :label="i18n.tkey('lang_exhibition_name')"
            prop="recordname"
            tkey="展會名稱"
        >
            <el-input
                v-model="dataForm.recordname"
                type="text"
                autocomplete="off"
                :disabled="readonlyTag"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_exhibition_name_en')"
            prop="addinfo6"
            tkey="展會英文名稱"
        >
            <el-input
                v-model="dataForm.addinfo6"
                type="text"
                autocomplete="off"
                :disabled="readonlyTag"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_apply_time')"
            required
            tkey="報名時間"
        >
            <el-form-item
                prop="addinfo1"
            >
                <el-input
                    type="date"
                    v-model="dataForm.addinfo1"
                    class="date-input"
                    :disabled="readonlyTag"
                />
            </el-form-item>

            <div class="center-box"><span>&nbsp;-&nbsp;</span></div>

            <el-form-item
                prop="addinfo2"
            >
                <el-input
                    type="date"
                    v-model="dataForm.addinfo2"
                    class="date-input"
                    :disabled="readonlyTag"
                />
            </el-form-item>

        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_open_time')"
            required
            prop="addinfo3"
            tkey="開放時間"
        >
            <el-form-item
                prop="addinfo3"
            >
                <el-input
                    type="date"
                    v-model="dataForm.addinfo3"
                    class="date-input"
                    :disabled="readonlyTag"
                />
            </el-form-item>

            <div class="center-box"><span>&nbsp;-&nbsp;</span></div>

            <el-form-item
                prop="addinfo4"
            >
                <el-input
                    type="date"
                    v-model="dataForm.addinfo4"
                    class="date-input"
                    :disabled="readonlyTag"
                />
            </el-form-item>

        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_area_text')"
            prop="addinfo5"
            tkey="地區"
        >
            <CountrySelector
                v-model="dataForm.addinfo5"
                :disabled="readonlyTag"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_exhibition_type')"
            prop="addinfo10"
            tkey="展會類型"
        >
            <el-select
                v-model="dataForm.addinfo10"
                size="large"
                :disabled="readonlyTag"
            >
                <el-option
                    :key="0"
                    :label="i18n.tkey('lang_world_hall')"
                    :value="'0'"
                />

                <el-option
                    :key="1"
                    :label="i18n.tkey('lang_local_hall')"
                    :value="'1'"
                />
            </el-select>
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('land_disable_auxiliary_collection')"
            tkey="統一收款"
        >
          <el-select
              :placeholder="i18n.tkey('land_disable_auxiliary_collection')"
              v-model="dataForm.addinfo23"
          >
            <el-option
                :key="'0'"
                :label="i18n.tkey('lang_enable')"
                :value="''"
            />
            <el-option
                :key="'1'"
                :label="i18n.tkey('lang_disable')"
                :value="'1'"
            />
          </el-select>
          <el-button v-if="dataForm.addinfo23 !='1'" @click="openSelectPayVisible=true">選擇付款方式</el-button>

        </el-form-item>
      <el-form-item
          :label="i18n.tkey('land_hall_model')"
          tkey="模型"
      >
        <el-select
            :placeholder="i18n.tkey('land_hall_model')"
            v-model="dataForm.addinfo24"
        >
          <el-option
              :key="'0'"
              :label="i18n.tkey('land_hall_exhibition_model')"
              :value="''"
          />
<!--          <el-option
              :key="'1'"
              :label="i18n.tkey('land_hall_exhibition_model2')"
              :value="'1'"
          />-->
          <el-option
              :key="'2'"
              :label="i18n.tkey('land_hall_exhibition_model3')"
              :value="'2'"
          />
        </el-select>
      </el-form-item>

<!--        <el-form-item-->
<!--            :label="i18n.tkey('lang_exhibition_stage')"-->
<!--            prop="addinfo17"-->
<!--            tkey="展會場景"-->
<!--        >-->

<!--            <el-select-->
<!--                v-model="dataForm.addinfo17"-->
<!--                size="large"-->
<!--                :disabled="readonlyTag"-->
<!--            >-->
<!--                <el-option-->
<!--                    :key="0"-->
<!--                    :label="i18n.tkey('lang_hall_1')"-->
<!--                    :value="'0'"-->
<!--                />-->

<!--                <el-option-->
<!--                    :key="1"-->
<!--                    :label="i18n.tkey('lang_market')"-->
<!--                    :value="'1'"-->
<!--                />-->
<!--            </el-select>-->
<!--        </el-form-item>-->

        <el-form-item
            :label="i18n.tkey('lang_exhibition_des')"
            prop="addinfo7"
            tkey="展會描述"
        >
            <el-input
                v-model="dataForm.addinfo7"
                type="text"
                autocomplete="off"
                :disabled="readonlyTag"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_exhibition_des_en')"
            prop="addinfo8"
            tkey="展會英文描述"
        >
            <el-input
                v-model="dataForm.addinfo8"
                type="text"
                autocomplete="off"
                :disabled="readonlyTag"
            />
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_exhibition_cover')"
            prop="addinfo11"
            tkey="展會封面"
            style="flex-direction: column;"
        >
          <div>
          <div class="img-size-label">
            <span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>800*400</span>
          </div>

                <UploadImg
                    v-model="dataForm.addinfo11"
                    :sizeLimit="500"
                    :readonlyTag="readonlyTag"
                    :width="300"
                    :height="150"
                    :useBtn="readonlyTag !== true"
                />
          </div>
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_exhibition_cover_en')"
            prop="addinfo12"
            tkey="展會英文封面"
            style="flex-direction: column;"
        >
          <div>
          <div class="img-size-label">
            <span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>800*400</span>
          </div>
                <UploadImg
                    v-model="dataForm.addinfo12"
                    :sizeLimit="500"
                    :width="300"
                    :height="150"
                    :readonlyTag="readonlyTag"
                    :useBtn="readonlyTag !== true"
                />
          </div>
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_exhibition_banner_img')"
            prop="addinfo15"
            tkey="展會條幅"
            style="flex-direction: column;"
        >
          <div>
          <div class="img-size-label">
          <span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>120*720</span>
        </div>
              <UploadImg
                  v-model="dataForm.addinfo15"
                  :sizeLimit="500"
                  :readonlyTag="readonlyTag"
                  :useBtn="readonlyTag !== true"
              />
          </div>
        </el-form-item>

        <el-form-item
            :label="i18n.tkey('lang_exhibition_banner_img_en')"
            prop="addinfo16"
            tkey="展會英文條幅"
            style="flex-direction: column;"
        >
          <div>
          <div class="img-size-label">
          <span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>120*720</span>
        </div>
                <UploadImg
                    v-model="dataForm.addinfo16"
                    :sizeLimit="500"
                    :readonlyTag="readonlyTag"
                    :useBtn="readonlyTag !== true"
                />
          </div>
        </el-form-item>
        <el-form-item
            :label="i18n.tkey('lang_start_promoting_images')"
            prop="addinfo25"
            tkey="彈出歡迎頁"
            style="flex-direction: column;"
        >
          <div>
          <div class="img-size-label">
            <span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>1600*900</span>
          </div>

            <UploadImg
                v-model="dataForm.addinfo25"
                :sizeLimit="500"
                :width="320"
                :height="180"
                :readonlyTag="readonlyTag"
                :useBtn="readonlyTag !== true"
            />
          </div>
        </el-form-item>

      <el-form-item
          :label="i18n.tkey('lang_end_promoting_images')"
          prop="addinfo26"
          tkey="開展完成後彈出窗"
          style="flex-direction: column;"
      >
        <div>
          <div class="img-size-label">
            <span tkey="圖片尺寸">{{i18n.tkey("lang_img_size_1")}}</span>&nbsp;<span>1600*900</span>
          </div>

          <UploadImg
              v-model="dataForm.addinfo26"
              :sizeLimit="500"
              :width="320"
              :height="180"
              :readonlyTag="readonlyTag"
              :useBtn="readonlyTag !== true"
          />
        </div>

      </el-form-item>
      <el-form-item
          :label="i18n.tkey('lang_end_promoting_links')"
          prop="addinfo27"
          tkey="完成後引導鏈接"
      >
        <el-input
            v-model="dataForm.addinfo27"
            type="text"
            autocomplete="off"
            :disabled="readonlyTag"
        />
      </el-form-item>

        <el-form-item>
            <div style="text-align: center; width: 100%">
                <el-button type="primary" @click="submitForm(formRef)" v-if="null == editObj" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
                <el-button type="primary" @click="submitForm(formRef)" v-if="null != editObj && readonlyTag !== true" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>

                <!--            <el-button @click="resetForm(formRef)">Reset</el-button>-->
            </div>
        </el-form-item>
    </el-form>

    <div
        v-if="null != editObj && (null == readonlyTag || false === readonlyTag)"
        class="edit-company-box"
    >
      <div v-if="dataType === 'company'">
        <PageTitle  :titleText="i18n.tkey('lang_join_hall_company')" />

        <HallCompanyEditor
            v-if="dataType === 'company'"
            :hallObj="editObj"
        />
      </div>
    <div v-if="dataType === 'product'">
      <PageTitle :titleText="i18n.tkey('lang_exhibited_products')" />
      <HallProductEditor
          v-if="dataType === 'product'"
          :hallObj="editObj"
      />
      </div>
    </div>
  <el-dialog
      v-model="openSelectPayVisible"
      :width="myUtil.isMobile() ? '90%' : '600px'"
      align-center
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <div v-if="openEidtPayVisible==false">
      <EditorTitle
          :showReturnBtn="false"
          :titleLabel="i18n.tkey('lang_select_payment_alert')"
          :showOperationBtn="true"
          :operationLabel="i18n.tkey('lang_add_paymethod_text')"
          @clickOperationBtn="openEidtPayVisible=true"
          tkey="收款方式"
      />

    <PaymentSelect
        :hallAddinfo28 ="dataForm.addinfo28"
        @chengSelectPayment="clikeChengPayment"
    />
    </div>
    <PaymentEditor v-if="openEidtPayVisible"
    @clickReturnBtn="openEidtPayVisible=false"
    />

  </el-dialog>


</template>

<script setup>
import {inject, reactive, ref, toRef, onBeforeMount, getCurrentInstance} from 'vue'
import {useCompanyinfo} from "@/stores/companyinfo";
import myUtil from "@/util/util";
import CountrySelector from "@/components/shopopee/country/countrySelector.vue";
import UploadImg from "@/components/shopopee/form/uploadImg.vue";
import record14Api from "@/request/record14Api";
import HallCompanyEditor from "@/components/shopopee/hallManager/hallCompanyEditor.vue";
import PageTitle from "@/components/shopopee/common/pageTitle.vue";
import HallProductEditor from "@/components/shopopee/hallManager/hallProductEditor.vue";
import PaymentSelect from "@/components/shopopee/payment/paymentSelect.vue";
import PaymentEditor from "@/components/shopopee/material/paymentEditor.vue";
import EditorTitle from "@/components/shopopee/common/editorTitle.vue";

const props = defineProps(["editObj", "readonlyTag"])
const emits = defineEmits(["save-complete"])

const { proxy } = getCurrentInstance()
const i18n = inject("i18n")
const reload = inject("reload");

//響應機制的companyinfo
const companyInfoRef = toRef(useCompanyinfo())

const loading = ref(false)

const openSelectPayVisible = ref(false)

const openEidtPayVisible = ref(false)

const dataType = ref("detail")




const formRef = ref(null)

const shopCompany = ref({})
const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return companyInfoRef.value } })

const rules = reactive({
    recordname: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo1: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo2: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo3: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo4: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo5: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],

    addinfo7: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo8: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo10: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo11: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    addinfo12: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
    // addinfo15: [
    //     { required: true, message: i18n.tkey("lang_enter_complete") },
    // ],
    // addinfo16: [
    //     { required: true, message: i18n.tkey("lang_enter_complete") },
    // ],
    addinfo17: [
        { required: true, message: i18n.tkey("lang_enter_complete") },
    ],
})

const dataForm = reactive({
    recordname: '',
    addinfo1: '',
    addinfo2: '',
    addinfo3: '',
    addinfo4: '',
    addinfo5: 'HK',
    addinfo6: '',
    addinfo7: '',
    addinfo8: '',
    addinfo10: '0',
    addinfo11: null,
    addinfo12: null,
    addinfo15: null,
    addinfo16: null,
    addinfo25: null,
    addinfo26: null,
    addinfo17: '0',
})

const submitForm = (formEl) => {
    if (!formEl) return
    formEl.validate((valid) => {
        if (valid) {
            if (null == props.editObj){
                submitData()
            }else{
                updateData()
            }

        }
    })
}

// const resetForm = (formEl) => {
//     if (!formEl) return
//     formEl.resetFields()
// }

function clikeChengPayment(paymentType){
  openSelectPayVisible.value = false
  if(myUtil.isNotEmpty(paymentType)){
    dataForm.addinfo28 = paymentType
  }
}

function changeType(mdataType){
  dataType.value = mdataType
}

function submitData() {
    loading.value = true

    const request = record14Api.insertRecord14
    const params = request.getParams()

    params.companycode = shopCompany.value.companycode
    params.recordname = dataForm.recordname
    params.addinfo1 = dataForm.addinfo1.replaceAll("-", "/")
    params.addinfo2 = dataForm.addinfo2.replaceAll("-", "/")
    params.addinfo3 = dataForm.addinfo3.replaceAll("-", "/")
    params.addinfo4 = dataForm.addinfo4.replaceAll("-", "/")
    params.addinfo5 = dataForm.addinfo5
    params.addinfo6 = dataForm.addinfo6
    params.addinfo7 = dataForm.addinfo7
    params.addinfo8 = dataForm.addinfo8
    params.addinfo10 = dataForm.addinfo10
    params.addinfo11 = dataForm.addinfo11
    params.addinfo12 = dataForm.addinfo12
    params.addinfo15 = dataForm.addinfo15
    params.addinfo16 = dataForm.addinfo16
    params.addinfo17 = dataForm.addinfo17
    params.addinfo23 = dataForm.addinfo23
    params.addinfo24 = dataForm.addinfo24
    params.addinfo25 = dataForm.addinfo25
    params.addinfo26 = dataForm.addinfo26
    params.addinfo27 = dataForm.addinfo27
    params.addinfo28 = dataForm.addinfo28

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            emits("save-complete")
        }else{
            myUtil.alertError(res.msg)
        }
    })


}

function updateData(){
    loading.value = true

    const request = record14Api.updateRecord14
    const params = request.getParams()

    params.id = props.editObj.id
    // params.companycode = shopCompany.value.companycode
    params.recordname = dataForm.recordname
    params.addinfo1 = dataForm.addinfo1.replaceAll("-", "/")
    params.addinfo2 = dataForm.addinfo2.replaceAll("-", "/")
    params.addinfo3 = dataForm.addinfo3.replaceAll("-", "/")
    params.addinfo4 = dataForm.addinfo4.replaceAll("-", "/")
    params.addinfo5 = dataForm.addinfo5
    params.addinfo6 = dataForm.addinfo6
    params.addinfo7 = dataForm.addinfo7
    params.addinfo8 = dataForm.addinfo8
    params.addinfo10 = dataForm.addinfo10
    params.addinfo11 = dataForm.addinfo11
    params.addinfo12 = dataForm.addinfo12
    params.addinfo15 = myUtil.isEmpty(dataForm.addinfo15)?"null":dataForm.addinfo15
    params.addinfo16 = myUtil.isEmpty(dataForm.addinfo16)?"null":dataForm.addinfo16
    params.addinfo17 = dataForm.addinfo17
    params.addinfo23 = dataForm.addinfo23
    params.addinfo24 = dataForm.addinfo24
    params.addinfo25 = myUtil.isEmpty(dataForm.addinfo25)?"null":dataForm.addinfo25
    params.addinfo26 = myUtil.isEmpty(dataForm.addinfo26)?"null":dataForm.addinfo26
    params.addinfo27 = dataForm.addinfo27
    params.addinfo28 = dataForm.addinfo28

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            emits("save-complete")
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

function goHallView(){
    proxy.$router.push({
        path: `/hall/${props.editObj.id}`
    })

    if (proxy.$route.path.indexOf("/hall") != -1){
        reload()
    }
}

function fillEditInfo(){

    dataForm.recordname = props.editObj.recordname
    dataForm.addinfo1 = props.editObj.addinfo1.replaceAll("/", "-")
    dataForm.addinfo2 = props.editObj.addinfo2.replaceAll("/", "-")
    dataForm.addinfo3 = props.editObj.addinfo3.replaceAll("/", "-")
    dataForm.addinfo4 = props.editObj.addinfo4.replaceAll("/", "-")
    dataForm.addinfo5 = props.editObj.addinfo5
    dataForm.addinfo6 = props.editObj.addinfo6
    dataForm.addinfo7 = props.editObj.addinfo7
    dataForm.addinfo8 = props.editObj.addinfo8
    dataForm.addinfo10 = props.editObj.addinfo10

    if(myUtil.isNotEmpty(props.editObj.addinfo11)){
      dataForm.addinfo11 = proxy.$ShopopeeUrl + props.editObj.addinfo11
    }
    if(myUtil.isNotEmpty(props.editObj.addinfo12)){
      dataForm.addinfo12 = proxy.$ShopopeeUrl + props.editObj.addinfo12
    }
    if(myUtil.isNotEmpty(props.editObj.addinfo15)){
      dataForm.addinfo15 = proxy.$ShopopeeUrl + props.editObj.addinfo15
    }
    if(myUtil.isNotEmpty(props.editObj.addinfo16)){
      dataForm.addinfo16 = proxy.$ShopopeeUrl + props.editObj.addinfo16
    }

    dataForm.addinfo17 = props.editObj.addinfo17
    dataForm.addinfo23 = myUtil.isEmpty(props.editObj.addinfo23)?"":props.editObj.addinfo23
    dataForm.addinfo24 = myUtil.isEmpty(props.editObj.addinfo24)?"":props.editObj.addinfo24
    if(myUtil.isNotEmpty(props.editObj.addinfo25)){
      dataForm.addinfo25 = proxy.$ShopopeeUrl + props.editObj.addinfo25
    }
    if(myUtil.isNotEmpty(props.editObj.addinfo26)){
      dataForm.addinfo26 = proxy.$ShopopeeUrl + props.editObj.addinfo26
    }
    dataForm.addinfo27 = myUtil.isEmpty(props.editObj.addinfo27)?"":props.editObj.addinfo27
    dataForm.addinfo28 = myUtil.isEmpty(props.editObj.addinfo28)?"":props.editObj.addinfo28

}

onBeforeMount(() => {
    shopCompany.value = getShopCompanyObj()

    if (null != props.editObj){
        fillEditInfo()
    }
})

</script>

<style scoped>
    .date-input {
        width: 100px;
    }

    .center-box {
        width: 45px;
        display: inline-block;
        text-align: right;
    }

    .edit-company-box {
        position: relative;
        margin-top: 30px;
        margin-bottom: 20px;
    }

    .img-size-label {
        color: #606266;
        text-align: left;
    }
</style>